//jqueryFree
import {setCookie} from "../../../../layout-common/js/parts/utils";

export default function () {

	//po odeslání reply, se (pokud máme referer) uživatel přesměruje na stránku s výpisem izerátů a po zobrazení flashmessage stránka secroluje na naposledy cliknutý inzerát
	let animationId;
	function hideFlashInTimeFadeOut(element) {
		element.style.opacity = 1;
		(function fade() {
			if ((element.style.opacity -= 0.1) < 0) {
				element.style.display = 'none';
			} else {
				animationId = requestAnimationFrame(fade);
			}
		})();
	}

	let offsetHeightCont = document.querySelector('.hide-flash-in-time');
	if (offsetHeightCont) {
		let offsetHeight = offsetHeightCont.clientHeight + 50;
		let anchor = window.location.hash.slice(1);
		setCookie('showmessage', '0', 60); // 1 min
		if (anchor !== undefined && anchor !== '' && document.getElementById(anchor) !== null) {
			setTimeout(function () {
				const targetElement = document.getElementById(anchor);

				if (targetElement) {
					const targetOffsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - offsetHeight;

					window.scrollTo({
						top: targetOffsetTop,
						behavior: 'smooth'
					});
				}
			}, 200);
		}
		let needRedirect = document.getElementById('referer-for-redirect');
		if (needRedirect) {
			try {
				let referer = needRedirect.dataset.referer;
				if (referer.length === 0) {
					setTimeout(function() {
						window.location.reload();
						hideFlashInTimeFadeOut(offsetHeightCont);
					}, 4000);
				}
			} catch (e) {
				//nothing
			}
		}
		setTimeout(function() {
			hideFlashInTimeFadeOut(offsetHeightCont);
		}, 9000);
	}

	window.addEventListener('beforeunload', function() {
		cancelAnimationFrame(animationId);
	});
}
